export const genderList = [
  {
    label: "Girl",
  },
  {
    label: "Boy",
  },
];
